"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wait = void 0;
/**
 * A convenience method used to simulate loading.
 * @param seconds The amount of seconds to wait.
 */
var wait = function (seconds) {
    return new Promise(function (res) {
        setTimeout(function () { return res(); }, seconds * 1000);
    });
};
exports.wait = wait;
